import { WorkflowSettings } from '@app/types/workflow-settings';

export enum Roles {
  COMPLETED_NO_POLICYNUMBER = 'COMPLETED_NO_POLICYNUMBER',
  COMPLETED = 'COMPLETED',
  ABANDONED = 'ABANDONED',
}

export type WeeklyBusinessHoursForm = {
  [key: string]: {
    enabled: boolean;
    startTime: string;
    endTime: string;
  };
};

export interface IWorkflowSettingsFormInput {
  workflowName: string;
  keywordTrigger: string;
  redirectPhoneNumber: string;
  organizationName: string;
  phoneNumber: string;
  organizationNameType: 'default' | 'custom';
  website: string;
  completionEmail: boolean;
  completionEmailAddresses: string[];
  completionEmailRoles: string[];
  enableSingleOptIn: boolean;
  enablePolicyLookup: boolean;
  enableClaimSubmission: boolean;
  escalation: boolean;
  timezone: string;
  escalationSchedule: WeeklyBusinessHoursForm | null;
  escalationEmailAddresses: string[];
  escalationPhoneNumber: string;
}

export interface WorkflowSettingsWithMetadata extends WorkflowSettings {
  workflowName: string;
  keywordTrigger?: string;
}
